'use strict';

angular.module('PinMeTo.directives').directive('pmtFormErrors', [
	function () {

		return {
			restrict: 'A',
			replace: true,
			scope: { formObject: '=pmtFormErrors' },
			link: function (/*scope, element, attrs*/) {},
			templateUrl: 'pmtShared/directives/pmtFormErrors.html'
		};
	}
]);
